import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-box relative max-w-screen-sm" }
const _hoisted_2 = { class: "flex justify-end pb-2" }
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = ["src", "alt"]

import {
  XMarkIcon,
} from '@heroicons/vue/24/outline';
import {
  onMounted,
  ref,
} from 'vue';
import RouteImagePlaceholder from '@/assets/site-assets/route-image.webp';
import CustomButton1 from '@/components/Helper/Button/CustomButton1.vue';
import {
  getFileSrc,
} from '@/helpers';
import type {
  IViewConfig,
} from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteImageModal',
  props: {
    routeModal: {}
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props;




const showModal = ref(false);
const imageSrc = ref(getFileSrc(props.routeModal.imageInfo.src));

function onImageError(): void {
  imageSrc.value = RouteImagePlaceholder;
}



const handleButtonClick = (): void => {
  emit('close');
  const { url } = props.routeModal.actionBtn;

  window.open(
    url,
    url.startsWith(window.location.origin) ? undefined : '_blank',
  );
};

onMounted(() => {
  window.setTimeout(() => {
    showModal.value = true;
  }, 1 * 1000);
});


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    id: "route-image-modal",
    class: "modal modal-open",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-circle border-0 font-bold",
          "aria-label": "Close Modal",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_unref(XMarkIcon), { class: "h-6 w-6 text-violet-600" })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: imageSrc.value,
          alt: _ctx.routeModal.imageInfo.altText,
          onError: onImageError
        }, null, 40, _hoisted_4)
      ]),
      _createVNode(CustomButton1, {
        content: _ctx.routeModal.actionBtn.text,
        category: "category-1",
        class: "mt-2 w-full px-4 py-2 sm:w-auto",
        onClick: handleButtonClick
      }, null, 8, ["content"])
    ])
  ], 512)), [
    [_vShow, showModal.value]
  ])
}
}

})